import * as XLSX from "xlsx";
import { getCsvColumnValue, getHeaderLabel, getProsjektColumns } from "./csvDownload";
import type { ProsjektRow } from "./types";

export function downloadProsjektExcel(filename: string, rows: ProsjektRow[]): void {
    if (typeof window === "undefined" || typeof document === "undefined") {
        return;
    }

    const columns = getProsjektColumns();
    const headerRow = columns.map(getHeaderLabel);
    const dataRows = rows.map((row) => columns.map((col) => getCsvColumnValue(row, col)));

    const worksheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Prosjektliste");
    XLSX.writeFile(workbook, filename);
}
